import { TFunction } from 'i18next';
import { ERROR_CODES } from 'models/ErrorCodes';
import { IClientFormFields } from 'modules/admin-panel/pages/clients/models';

import { LOGO_MAX_SIZE, MAILING_LIST_MAX_SIZE } from 'utils';

export const getClientFormInputName = (field: string): string => {
	if (field === 'contractDto.endDate') {
		return IClientFormFields.contractEndDate;
	}

	if (field === 'contractDto.startDate') {
		return IClientFormFields.contractStartDate;
	}

	return field;
};

export const getClientFormErrorMap = (t: TFunction) => {
	return {
		[ERROR_CODES.MISS_MATCH]: {
			[IClientFormFields.shortName]: t('invalid_symbols', {
				allowedSymbols: 'letters A-Z, upper-lower cases, integ. 0-9',
			}),
			[IClientFormFields.formalName]: t('invalid_symbols', {
				allowedSymbols:
					'letters A-Z, upper- lover cases, integ. 0-9, special char. &():;"',
			}),
			[IClientFormFields.domainName]: t('invalid_symbols', {
				allowedSymbols:
					'letters A-Z, upper-lower cases, integ. 0-9, special char. -.',
			}),
			[IClientFormFields.website]: t('incorrect'),
			[IClientFormFields.color]: t('invalid_color_value'),
			[IClientFormFields.comment]: t('invalid_symbols', {
				allowedSymbols:
					'A-Z, upper-lover cases, int. 0-9, special char ~!@#$%^&*_-+=`|(){}[]:;"\'<>,.?/ and spaсe',
			}),
		},
		[ERROR_CODES.INVALID_LENGTH]: {
			[IClientFormFields.shortName]: t('invalid_length'),
			[IClientFormFields.formalName]: t('invalid_length'),
			[IClientFormFields.domainName]: t('invalid_length'),
			[IClientFormFields.website]: t('invalid_length'),
		},
		[ERROR_CODES.REQUIRED]: {
			[IClientFormFields.shortName]: t('required'),
			[IClientFormFields.formalName]: t('required'),
			[IClientFormFields.domainName]: t('required'),
			[IClientFormFields.website]: t('required'),
			[IClientFormFields.logo]: t('required'),
			[IClientFormFields.color]: t('required'),
			[IClientFormFields.contractEndDate]: t('required'),
			[IClientFormFields.contractStartDate]: t('required'),
			[IClientFormFields.clientUserCountLimit]: t('required'),
			[IClientFormFields.limitPerClientId]: t('required'),
			[IClientFormFields.surveyCountLimit]: t('required'),
			[IClientFormFields.comment]: t('required'),
		},
		[ERROR_CODES.MAX_SIZE]: {
			[IClientFormFields.logo]: t('file_size_not_more', {
				size: LOGO_MAX_SIZE,
			}),
			[IClientFormFields.mailingListKey]: t('file_size_not_more', {
				size: MAILING_LIST_MAX_SIZE,
			}),
		},
		[ERROR_CODES.INVALID_FORMAT]: {
			[IClientFormFields.logo]: t('format_not_supported'),
			[IClientFormFields.mailingListKey]: t('format_not_supported'),
		},
		[ERROR_CODES.PAST_DATE]: {
			[IClientFormFields.contractEndDate]: t('invalid_end_date'),
		},
	};
};
